"use client";
import { DerivableLogo } from "../icons/index";
import config from "../config/team.json";
import { homeURL } from "./lib/site";

const SiteHeader = () => {
  const { navigation } = config;
  return (
    <div className="flex flex-col items-start fixed w-full h-[64px] md:h-[80px] background-gray top-0 z-[9999]">
      <nav className="flex flex-row justify-between px-4 lg:px-[120px] py-0 w-full h-full border-b-[1px] border-zinc-700">
        <div className="flex justify-center items-center h-full shrink-0">
          <a href={homeURL("/")}>
            <DerivableLogo />
          </a>
        </div>
        <div className="flex flex-row justify-end items-center gap-4 md:gap-[56px] self-stretch h-full">
          {navigation.map((item, index) => (
            <a
              key={index}
              href={homeURL(item.href)}
              target={item.target}
              rel={item.target === "_blank" ? "noreferrer" : undefined}
              className="h-full"
            >
              <div className="h-full button-link box-border flex flex-row items-center py-2 gap-2 text-heading text-[11px] md:text-sm text-grey-1">
                {item.name}
              </div>
            </a>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default SiteHeader;
